import React from "react";
import SvgIcon from "../../../parts/SvgIcon";

function MetricsBackButton({ url, text, classNames = "" }) {
  return (
    <a href={url} className={classNames}>
      <SvgIcon src="/img/new-icons/arrow-square-left-2.svg" />
      {text ? text : ""}
    </a>
  );
}

export default MetricsBackButton;
